export default "__VITE_ASSET__ea9e6065__"